import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import Filter from "../Components/Filter";
import { fetchCmsMetaData } from "../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../Components/Utility/setMetaTags";

function ExperienceListing() {
  const location = useLocation();
  const [meta,setMeta] = useState();

  // ✅ Initial search results
  // const initialResults = location.state?.results || [];
  // const currency = location.state?.currency || [];
   
  // const [results, setResults] = useState(initialResults);
  const [results, setResults] = useState([]);
  const [currency, setCurrency] = useState({});

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const filters = location.state?.filters || {};
const [selectedDate, setSelectedDate] = useState(filters.date || null);

const [searchParams] = useSearchParams();

const locationSearch = searchParams.get("location_search") || "";
const arrive = searchParams.get("arrive") || "";
const depart = searchParams.get("depart") || "";
const guest = searchParams.get("guest") || 0;
const [loading, setLoading] = useState(true);


// useEffect(() => {
//   if (filters.date) {
//     setSelectedDate(filters.date);
//   }
// }, [filters.date]);

useEffect(() => {
  const fetchListingFromUrl = async () => {
    try {
      setLoading(true);

      const params = {
        search: locationSearch,
        date: arrive && depart
          ? `${arrive} to ${depart}`
          : arrive || "",
        guest,
      };

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/getHomeExperienceSearch`,
        { params }
      );

      if (res.data?.status && Array.isArray(res.data.data)) {
        const formatted = res.data.data.map((item) => ({
          ...item,
          base_url: res.data.base_url,
        }));

        setResults(formatted);
        setCurrency(res.data.currency || {});
      } else {
        setResults([]);
      }
    } catch (err) {
      console.error(err);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  fetchListingFromUrl();
}, [locationSearch, arrive, depart, guest]);



  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location.state]);

   useEffect(() => {
    if (location.state?.results) {
      setResults(location.state.results);
    }
  }, [location.state]);

  // 🔹 Apply Filter API
  const handleFilterApply = async (filters) => {
  try {
    // merge initialResults + selected filters
    const queryObj = { city_id: 133230, ...filters };

    const query = new URLSearchParams(queryObj).toString();

    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE}/getHomeExperienceSearch?${query}`
    );

    if (res.data?.status) {
      // merge previous search + filtered results
     const combinedResults = res.data.data.map(item => ({
    ...item,
    base_url: res.data.base_url // attach base_url to each item if needed
  }));
      setResults(combinedResults);
      
    }else{
 setResults("");
    }
   
   
  } catch (error) {
    console.error("Error filtering experiences:", error);
  } finally {
    setIsFilterOpen(false);
  }
};


 useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("experiences");
      setMeta(data);
    };

    loadMeta();
  }, []);

  return (
    <>
      <section className="ser_v_araeea manngess listingpgss ">
        <SetMetaTags
        title= {meta?.meta_title || "Experiences | Weyfarin"}
        description={meta?.meta_description || "Experiences | Weyfarin"}
      
      />
        <div className="container">
          <div className="al_sec_ctxt manages_iconss">
            <h2>
              Experiences
              <span className="al_rightsss">
                <button
                  className="ftl_btns hidethis"
                  onClick={() => setIsFilterOpen(true)}
                >
                  <img
                    src="/images/controls-alt.png"
                    className="filttersic mb_view_show"
                    alt=""
                  />{" "}
                  Filter
                </button>
              </span>
            </h2>
          </div>

          <div className="row">
            {/* {results.length > 0 ? ( */}
            {loading ? (
  <div className="col-lg-12 text-center">
    <p>Loading...</p>
  </div>
) : results.length > 0 ? (
              results.map((exp, index) => (
                <div className="col-lg-3" key={index}>
                 <Link
  className={`bike_ara_all ${index === 0 ? "highlight-exp" : ""}`}
  // to={`/experience/${
  //   (exp?.title
  //     ? exp.title.replace(/[\s,]+/g, "-").toLowerCase()
  //     : "unknown")
  // }-${exp?.experience_id || "0"}`}
  to={`/experience/${exp.url_slug}`}
   state={{ date: selectedDate, filters }}
  
>

                    <div className="bike_mg_ar">
                      {exp.rating > 0 && (
                        <span className="reatingsg">
                          {exp.rating} <i className="fa fa-star"></i>
                        </span>
                      )}
                      <div className="mdll">
                        <img
                          // src={exp.img}
                          src={exp.img || (exp.image ? `${exp.base_url}${exp.image}` : "/images/placeholder.png")}
                          className="mg_sm_araea"
                          alt={exp.title}
                        />
                      </div>
                    </div>
                    <div className="tx_box">
                      <h4>{exp.title}</h4>
                      <p>
                        {/* {exp.city_name}, {exp.country_name} */}
                        {[exp.city_name, exp.country_name].filter(Boolean).join(", ")}
                      </p>
                      <span>From {currency?.currency_symbol || "$"}{Number(exp.price || 0).toFixed(2)}/guest</span>
                    </div>
                  </Link>
                </div>
              ))
            ) : (
              <div className="col-lg-12 al_bootm_spance1">
                <p className="text-center">
                  <strong>No experiences found.</strong>
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* 🔹 Filter Popup */}
      <Filter
        isOpen={isFilterOpen}
        onClose={() => setIsFilterOpen(false)}
        onApply={handleFilterApply}
      />
    </>
  );
}

export default ExperienceListing;
